import { Component, input, viewChild, output } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideUpload } from '@ng-icons/lucide';
import { HlmIcon } from '../../../ui/icon/src';
import { HlmButton } from '../../../ui/button/src';

@Component({
    selector: 'app-file-uploader',
    template: `
    <div>
      <input #uploader type="file" [accept]="allowedExtensions()" hidden (change)="onFileChange($event)" />
      <button hlmBtn variant="outline" (click)="uploader.click()" [disabled]="isBtnDisabled()">
        {{ btnText() }}
        <ng-icon hlm name="lucideUpload" />
      </button>
    </div>
  `,
    styles: [],
    imports: [HlmButton, NgIcon, HlmIcon],
    providers: [provideIcons({ lucideUpload })]
})
export class FileUploaderComponent {
  readonly uploader = viewChild<any>('uploader');

  readonly fileChange = output<File>();

  readonly btnText = input('Upload file');

  readonly isBtnDisabled = input<boolean>(false);

  readonly allowedExtensions = input(['.xlsx', '.xls', '.csv']);

  constructor() {}

  onFileChange(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    const fileList: FileList | null = element.files;
    if (fileList && fileList.length) {
      const file: File = fileList[0];
      this.fileChange.emit(file);
      this.uploader().nativeElement.value = '';
    }
  }
}
